import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { forwardRef } from "react";

export type IconSize = "sm" | "md" | "lg";

interface IconProps extends Omit<FontAwesomeIconProps, "size"> {
  size?: IconSize;
}

const sizeMap: Record<IconSize, FontAwesomeIconProps["size"]> = {
  sm: "1x",
  md: "2x",
  lg: "3x",
};

const BaseIcon = forwardRef<SVGSVGElement, IconProps>(({ icon, size = "sm", ...props }, ref) => {
  return <FontAwesomeIcon icon={icon} ref={ref} size={sizeMap[size]} {...props} />;
});

/**
 * A component that renders an icon.
 * The icons are available via import from @icons
 *
 * @param size - The size of the icon. Options: "sm" (1x), "md" (2x), "lg" (3x)
 *
 * @example
 * ```
 * import { Icon } from "@ui";
 * import { faCheck } from "@icons/regular";
 *
 * <Icon icon={faCheck} size="md" />
 * ```
 */
export const Icon = BaseIcon;
